/**
 * Host-Split Techniker/Kunden: Die App wird unter zwei Domains ausgeliefert
 * (servicehub.fixbyte.it für Techniker, kundenportal.fixbyte.it für Kunden).
 * Auf dem Kunden-Host zeigen wir ausschließlich das Kundenportal — die Pfade
 * bleiben identisch (/customer/*), nur die Einstiegs-Navigation unterscheidet sich.
 */
export function isCustomerPortalHost(hostname: string = window.location.hostname): boolean {
  return hostname === 'kundenportal.fixbyte.it' || hostname.startsWith('kundenportal.');
}
